// src/features/home/Hero.jsx
import { Link } from "react-router-dom";
import Container from "../../components/ui/Container";
import Button from "../../components/ui/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp, faTiktok } from "@fortawesome/free-brands-svg-icons";
import { useState, useRef } from "react";

const Hero = () => {

    const [modalType, setModalType] = useState(null);
    const hoverTimeout = useRef(null);

    const openModal = (type) => {
        clearTimeout(hoverTimeout.current);
        setModalType(type);
    };

    const closeModal = () => {
        hoverTimeout.current = setTimeout(() => {
            setModalType(null);
        }, 250);
    };

    const WhatsAppMessage = (e) => {

        const businessPhone = "27743528641";
        const userMessage = `Hello, I would like to know more about your Maths and Physical Science classes.`;
        const encodedMessage = encodeURIComponent(userMessage);

        // Detect mobile vs desktop
        const isMobile = /iPhone|Android|iPad|iPod/i.test(navigator.userAgent);
        let url = `https://wa.me/${businessPhone}?text=${encodedMessage}`;
        if (!isMobile) {
            url = `https://web.whatsapp.com/send?phone=${businessPhone}&text=${encodedMessage}`;
        }

        window.open(url, "_blank");

    };

    return (
        <>
            {/* Hero Section */}
            <section className="text-white overflow-hidden">
                {/* Background pattern / abstract shapes */}


                <Container className="relative py-6 sm:py-16">
                    <div className="max-w-3xl mx-auto text-center">
                        <h1 className="text-4xl md:text-5xl lg:text-5xl font-extrabold leading-tight mb-16">
                            {/*Unlock Your Academic Potential with{" "} <br/>*/}
                            <span className="text-gray-300">SPK Academy & Publishing</span>
                        </h1>
                        <p className="text-xl px-2 md:text-2xl mb-10 sm:mb-28 text-blue-100">
                            Expert-led online classes, assessment books, and personalised tutoring
                            in Mathematics and Physical Sciences.
                        </p>

                        {/* CTA Buttons */}
                        <div className="flex flex-row gap-2 justify-center">
                            <Link to="/books">
                                <Button
                                    size="sm"
                                    variant="primary"
                                    className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 border-0"
                                >
                                    Browse Books
                                </Button>
                            </Link>
                            <Link to="/classes">
                                <Button
                                    size="sm"
                                    variant="outline"
                                    className="border-white text-white hover:bg-white hover:text-blue-600"
                                >
                                    Explore Classes
                                </Button>
                            </Link>
                            <Link to="/services">
                                <Button
                                    size="sm"
                                    variant="outline"
                                    className="border-white text-white hover:bg-white hover:text-blue-600"
                                >
                                    View All Services
                                </Button>
                            </Link>
                        </div>

                        {/* Social icons */}

                        <div className="mt-6 flex justify-center gap-6 text-blue-200 relative">

                            {/* WhatsApp */}
                            <div className="relative">
                                <div
                                    onMouseEnter={() => openModal("whatsapp")}
                                    onMouseLeave={closeModal}
                                    className="cursor-pointer text-green-300 hover:text-white transition"
                                >
                                    <FontAwesomeIcon icon={faWhatsapp} className="w-7 h-auto" />
                                </div>

                                {/* Floating WhatsApp Preview */}
                                {modalType === "whatsapp" && (
                                    <div className="absolute -top-36 left-1/2 transform -translate-x-1/2 w-80 p-3 bg-white rounded-lg shadow-lg z-50 text-gray-800"
                                        onMouseEnter={() => clearTimeout(hoverTimeout.current)}
                                        onMouseLeave={closeModal}>
                                        <p className="text-sm mb-2 font-semibold text-left">Start a conversation with SPK Academy</p>
                                        <div className="bg-green-50 p-2 w-60 rounded shadow text-sm text-left mb-8">
                                            Hello, I would like to know more about your Maths and Physical Science classes.
                                        </div>

                                        <span
                                            onClick={WhatsAppMessage}
                                            className="block text-center bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600 transition"
                                        >
                                            Continue on WhatsApp
                                        </span>
                                    </div>
                                )}
                            </div>

                            {/* TikTok */}
                            <div className="relative">
                                <div
                                    onMouseEnter={() => openModal("tiktok")}
                                    onMouseLeave={closeModal}
                                    className="cursor-pointer text-gray-400 hover:text-white transition"
                                >
                                    <FontAwesomeIcon icon={faTiktok} className="w-7 h-auto" />
                                </div>

                                {/* Floating TikTok Preview */}
                                {modalType === "tiktok" && (
                                    <div className="absolute -top-64 left-1/2 transform -translate-x-1/2 w-64 p-2 bg-black rounded-lg shadow-lg z-50"
                                        onMouseEnter={() => clearTimeout(hoverTimeout.current)}
                                        onMouseLeave={closeModal}>

                                        <video
                                            src="media/img/testimonial.mp4"
                                            className="w-full aspect-video rounded"
                                            autoPlay
                                            title="TikTok video preview"
                                        />
                                        <a
                                            href="https://www.tiktok.com/@spk.academy.and.p?_r=1&_t=ZS-94i20t7hjXU"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="block text-center mt-2 text-white bg-gray-800 px-2 py-1 rounded hover:bg-gray-700 transition"
                                        >
                                            Visit TikTok Page
                                        </a>
                                    </div>
                                )}
                            </div>

                        </div>




                        {/* Trust Badge */}
                        <div className="mt-4 flex items-center justify-center gap-2 text-sm text-blue-200">
                            <div className="flex items-center gap-2">
                                <svg
                                    className="w-5 h-5"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                                <span>50+ students enrolled</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <svg
                                    className="w-5 h-5"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                >
                                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                </svg>
                                <span>4.9 rating (50+ reviews)</span>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            {/* The rest of your home page content (if any) can go here */}
            {/* For now, we'll keep the existing simple layout or you can add more sections */}
            <Container className="py-2 text-center">
                <h2 className="text-3xl font-bold mb-8 text-white">Why Choose SPK Academy & Publishing?</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-8">
                    <div className="p-2 bg-white rounded-lg shadow">
                        <h3 className="text-xl font-semibold mb-2">Expert Tutors</h3>
                        <p>Qualified educators with years of experience.</p>
                    </div>
                    <div className="p-2 bg-white rounded-lg shadow">
                        <h3 className="text-xl font-semibold mb-2">Comprehensive Materials</h3>
                        <p>Curriculum-aligned books and resources.</p>
                    </div>
                    <div className="p-2 bg-white rounded-lg shadow">
                        <h3 className="text-xl font-semibold mb-2">Flexible Learning</h3>
                        <p>Choose from video lessons, group classes, or one-on-one.</p>
                    </div>
                </div>
            </Container>

        </>
    );
};

export default Hero;